<template>

  <v-row>
    <v-col cols="12">
      <v-row v-if="(check_failures.keys || []).length === 0">
        <v-col cols-4 v-for="(k, v) in check_failures" :key="v">
          <div class="error--text" v-if="v === 'has_been_checked_for_duplicates'">Customer has not been checked for duplicates</div>
          <div class="error--text" v-if="v === 'not_a_duplicate'">Customer has a duplicate account</div>
          <div class="error--text" v-if="v === 'has_an_onboarding_assessment'">Customer onboarding has not been approval</div>
          <div class="error--text" v-if="v === 'age_limit_check'">Customers age has exceeded required limit </div>
        </v-col>
        <v-col cols-4><div class="error--text" v-if="customer.demographic['isFingerprintEnrolled?'] != true">Customers Fingerprints not enrolled</div></v-col>
      </v-row>
    </v-col>

    <v-col cols="12" sm="6">
      <v-card class="text-left" style="width: 100%;">
        <v-card-text>
          <v-container fluid class="text-h5">
            <v-row :class="{ 'red--text': !sufficientCashOnHand }">
              <v-col>Cash</v-col>
              <v-col>
                <CurrencyInput :disabled="arrears" v-model="cash" :rules="[v => v <= 1000000 || 'Maximum cash is Tsh 1,000,000']"/>
                <div v-if="arrears" :class="disableClass"><span>client has standing arrears</span></div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>EFT</v-col>
              <v-col>
                <CurrencyInput :disabled="arrears || !bankAccount" v-model="eft" />
                <div v-if="arrears" :class="disableClass"><span>client has standing arrears</span></div>
                <div v-if="!bankAccount"><span :class="disableClass">client does not have bank details available.</span></div>
              </v-col>
            </v-row>
            <v-row v-if="false">
              <v-col>Mobile Money</v-col>
              <v-col>
                <CurrencyInput :disabled="arrears || !mpesaAccount" v-model="mobileMoney" />
                <div v-if="arrears" :class="disableClass"><span>client has standing arrears</span></div>
                <div v-if="!mpesaAccount" :class="disableClass"><span>No telephone number.</span></div>
              </v-col>
            </v-row>
            <v-row v-if="topup">
              <v-col>Transfer</v-col>
              <v-col><Currency v-model="transfer" /></v-col>
            </v-row>

            <v-row v-if="showAccountStatus" class="text-caption">
              <v-col cols="6" v-if="eft>0"><BankDetails :customer="customer" /></v-col>
              <v-col cols="6" v-if="!bankAccount" class="red--text">No bank details available.</v-col>
              <v-col cols="6" v-if="mobileMoney>0">Mobile Money Wallet: <Telephone :msisdn="customer.msisdn"/></v-col>
              <v-col cols="6" v-if="!mpesaAccount" class="red--text">No telephone number.</v-col>
            </v-row>

          </v-container>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6">
      <v-card class="text-left" style="width: 100%;">
        <v-card-text>
          <v-container fluid class="text-h5">
            <v-row :class="{'red--text': (principal>maxPrincipal)}">
              <v-col>New Principal</v-col>
              <v-col><Currency v-model="principal" /></v-col>
            </v-row>
          </v-container>
          <v-container v-if="pricing === undefined">
            <v-row align="center" justify="center">
              <v-progress-circular indeterminate color="primary" :size="60" :width="8" />
            </v-row>
          </v-container>
          <v-container fluid class="text-h5" v-else>
            <v-row v-if="pricing">
              <v-col>Nett Disbursement</v-col>
              <v-col><Currency v-model="cashDisbursal" /></v-col>
            </v-row>
            <v-row v-if="pricing">
              <v-col>Interest</v-col>
              <v-col><Currency v-model="pricing.interest" /></v-col>
            </v-row>
            <v-row v-if="pricing">
              <v-col>Total Repayable</v-col>
              <v-col><Currency v-model="pricing.total_repayable" /></v-col>
            </v-row>
            <v-row v-if="pricing">
              <v-col>Repay On</v-col>
              <v-col><Time :time="pricing.repay_at" format="d MMM yyyy" /></v-col>
            </v-row>
            <v-row v-if="pricing">
              <v-col>Monthly Interest</v-col>
              <v-col>{{pricing.interest_rate*100.0}} %</v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-btn color="success" style="width: 100%;" :disabled="!valid" @click="$emit('agreed')">
        Submit
      </v-btn>
    </v-col>

    <v-col cols="12">
      <v-container fluid>
        <v-row>
          <v-col cols="6" :class="{ 'red--text': !sufficientCashOnHand }">
            Cash on hand: <Currency v-model="cashBoxBalance" />
          </v-col>
          <v-col cols="6" v-if="maxPrincipal">
            Limits:
            <Currency v-model="minPrincipal" />
            to
            <Currency v-model="maxPrincipal" />
          </v-col>
        </v-row>
      </v-container>
    </v-col>

  </v-row>



</template>

<script>
import lookups from '@/mixins/lookups';

import Time from '@/components/Time';
import CurrencyInput from "@/components/CurrencyInput";
import TextInput from "@/components/TextInput";
import Currency from "@/components/Currency";
import ServerSideResult from "@/components/ServerSideResult";
import Telephone from "@/components/Telephone";
import BankDetails from '@/views/partners/ultimate_tz/components/BankDetails'

export default {

  components: { Time, CurrencyInput, TextInput, Currency, ServerSideResult, Telephone, BankDetails },

  props: {
    value: {},
    customer: {
      type: Object,
      required: true,
    },
    loanParameters: {
      type: Object,
      required: true,
    },
    topup: {
      type: Number,
      required: false,
    },
    transfer: {
      type: Number,
      required: false,
    },
    arrears: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  

  data() {
    return {
      mobileMoney: 0,
      cash: 0,
      eft: 0,
      minPrincipal: 50000,

      pricing: undefined,
      serverPricing: undefined,

      cashBoxBalance: 0,
      checks: {},
    }
  },

  computed: {
    bankAccount() { return (this.customer.account_number || '').length>6; },
    mpesaAccount() { return (this.customer.msisdn || '').length>9; },
    showAccountStatus() {
      let r = false;
      if (!this.bankAccount) { r = true; }
      if (!this.mpesaAccount) { r = true; }
      if (this.mobileMoney>0) { r = true; }
      if (this.eft>0) {  r= true; }
      return r;
    },
    check_failures() {
      return Object.fromEntries(Object.entries(this.checks).filter(([key, value]) => value === false));
    }, 

    sufficientCashOnHand() { return this.cashBoxBalance>=parseInt(this.cash || 0); },

    maxPrincipal() { return ((this.loanParameters || {}).limit || 0); },

    principal() { return parseInt(this.mobileMoney || 0) + parseInt(this.cash || 0) + parseInt(this.eft || 0) + parseInt(this.transfer || 0) },
    cashDisbursal() { return parseInt(this.mobileMoney || 0) + parseInt(this.cash || 0) + parseInt(this.eft || 0); },
    interest() { return this.principal*this.interest_rate; },
    repayable() { return this.principal; },
    installment() { return this.repayable / this.installments },
    installmentDay() { return (this.customer.employer.payload || {}).payrollDay; },

    valid() {
      let r = true;
      if (r) { r = !!this.pricing }
      if (r) { r = (this.principal >= this.minPrincipal); }
      if (r) { r = !!this.maxPrincipal; }
      if (r) { r = (this.principal <= this.maxPrincipal); }
      if (r) { r = this.sufficientCashOnHand; }
      if (r) { r = this.cash <= 1000000}
      if (r) { r = Object.entries(Object.fromEntries(Object.entries(this.checks).filter(([key, value]) => value === false))).length === 0 }
      return r;
    },

    results() {
      let r = undefined;
      if (this.valid && this.pricing) {
        r = {
          uuid: this.customer.uuid,
          principal: this.pricing.principal,
          interest_rate: this.pricing.interest_rate,
          repay_at: this.pricing.repay_at,
          cash: this.cash,
          eft: this.eft,
          mobileMoney: this.mobileMoney,
          transfer: this.transfer,
          payroll_day: this.pricing.payroll_day,
        }
      }
      return r;
    },
    disableClass() {
      return "input-error v-text-field__details text-disabled"
    },
  },

  watch: {
    principal(to) {
      this.setPricing();
    },
    cash(to) {
      
    },
    serverPricing: {
      deep: true,
      immediate: true,
      handler(to) {
        let e = (to || {});
        this.pricing = undefined
        console.log("this.pricing.principal: ", e.principal)
        console.log("this.principal: ", this.principal)
        if(e.principal === this.principal) {
          this.pricing = {
            principal: e.principal,
            limit: e.limit,
            allowed: e.allowed,
            interest_rate: e.interest_rate,
            interest: e.interest,
            total_repayable: e.total_repayable,
            repay_at: e.repay_at,
            payroll_day: e.payroll_day,
          }
        }
      }

    },
    results: {
      deep: true,
      handler(to) {
        this.$emit('input', to);
      }
    },

  },

  methods: {
    setPricing() {
      this.pricing = undefined
      if(this.principal >= this.minPrincipal && !!this.maxPrincipal && this.principal <= this.maxPrincipal) {
        this.remoteLookup('ultimate_tz_salary_advance_pricing', { uuid: this.customer.uuid, principal: this.principal, topup: this.topup }).then( pricing => this.serverPricing = pricing ).catch(e => this.pricing = undefined);
      }
    },
  },

  mounted() {

    this.remoteLookup('ultimate_tz_cash_box_balance', {}).then( balance => { 
      this.cashBoxBalance = (balance.balance/100.0);
      this.setPricing();
      let credit_limit =  this.maxPrincipal - (this.transfer || 0);
      credit_limit = (Math.floor(credit_limit / 1000) * 1000);
      this.cash = credit_limit < this.cashBoxBalance ?  credit_limit : this.cashBoxBalance
    
     }).catch(e => this.cashBoxBalance = 0);

     this.remoteLookup('ultimate_tz_preloan_checks', {customerUuid: this.customer.uuid}).then(checks => {
      this.checks = checks
     })
  },

  mixins: [lookups],

}
</script>

<style scoped>

.input-error{
  font-size: 12px;
  line-height: 12px;
  margin-top: 0;
  color: red;
}

</style>